import { render, staticRenderFns } from "./AddPaymentVoucher.vue?vue&type=template&id=4a825a7a&"
import script from "./AddPaymentVoucher.vue?vue&type=script&lang=js&"
export * from "./AddPaymentVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports